import type { AgentKind } from '@warriorlab/shared';

/**
 * The agent taxonomy, in product language. Specialists do the analysis.
 * Orchestrators coordinate specialists and own the synthesis. Playbooks
 * script multi-step routines. Display order: top of the hierarchy first.
 */
export const TIER_ORDER: AgentKind[] = ['orchestrator', 'agent', 'playbook'];

export const TIER_META: Record<AgentKind, { label: string; plural: string; blurb: string }> = {
  orchestrator: {
    label: 'Orchestrator',
    plural: 'Orchestrators',
    blurb: 'Coordinates specialists and owns the synthesis.',
  },
  agent: {
    label: 'Specialist',
    plural: 'Specialists',
    blurb: 'Does the analysis.',
  },
  playbook: {
    label: 'Playbook',
    plural: 'Playbooks',
    blurb: 'Scripts a multi-step routine.',
  },
};
